"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBannedCommunitiesResponseToJSON = exports.GetBannedCommunitiesResponseFromJSONTyped = exports.GetBannedCommunitiesResponseFromJSON = void 0;
var _1 = require("./");
function GetBannedCommunitiesResponseFromJSON(json) {
    return GetBannedCommunitiesResponseFromJSONTyped(json, false);
}
exports.GetBannedCommunitiesResponseFromJSON = GetBannedCommunitiesResponseFromJSON;
function GetBannedCommunitiesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bannedCommunities': (json['bannedCommunities'].map(_1.BannedCommunityFromJSON)),
    };
}
exports.GetBannedCommunitiesResponseFromJSONTyped = GetBannedCommunitiesResponseFromJSONTyped;
function GetBannedCommunitiesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bannedCommunities': (value.bannedCommunities.map(_1.BannedCommunityToJSON)),
    };
}
exports.GetBannedCommunitiesResponseToJSON = GetBannedCommunitiesResponseToJSON;
